export class getSettings {
    public static data: any = {
        Id: 0,
        FirstName: "",
        LastName: "",
        EmailAddress: {
            Value: "",
            Locked: false
        },
        TelNumber: {
            Value: "",
            Locked: false
        },
        JobTitle: {
            Value: null,
            Locked: false
        },
        UserImage: {
            Value: "",
            Locked: false
        },
        WorkingDays: {
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
            Saturday: false,
            Sunday: false
        },
        DefaultWorkPlaces: {
            Monday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Tuesday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Wednesday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Thursday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Friday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Saturday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Sunday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ]
        },
        WorkPlaceVisibility: "",
        DateFormat: "",
        Is24HrFormat: true,
        FirstDayOfWeek: "",
        DefaultLocation: {
            LocationId: 0,
            Country: "",
            City: "",
            Site: "",
            Building: "",
            Floor: "",
            Zone: "",
            Locked: false
        },
        Departments: [
            {
                Id: 0,
                Name: "",
                Manager: 0,
                Members: [
                    0
                ],
                Teams: null
            }
        ],
        Teams: [
            {
                Id: 0,
                Name: "",
                TeamLeader: [],
                Members: [
                    0,
                    0
                ]
            }
        ],
        BookableLocations: [],
        ViewableLocations: []
    }

    public static AssignedSpacedata: any = {
        UserId: 0,
        EmailAddress: "",
        AssignedSpace: [],
        ErrCode: null,
        ErrDesc: null
    }

    public static MysettingsBasicdata: any = [{
        Id: 0,
        FirstName: "",
        LastName: "",
        EmailAddress: "",
        TelNumber: "",
        JobTitle: null,
        UserImage: "",
        DateFormat: "",
        Is24HrFormat: false,
        AccessCode: "",
        FirstDayOfWeek: "",
        WorkingDays: {
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
            Saturday: false,
            Sunday: false
        },
        DefaultLocation: {
            LocationId: 0,
            Country: "",
            City: "",
            Site: "",
            Building: "",
            Floor: "",
            Zone: "",
            Locked: false
        },
        AssignedSpace: [
            {
                ResId: 0,
                ResName: "",
                SpaceType: "",
                IconPath: null,
                MapId: [
                    0
                ]
            }
        ],
        Teams: [
            // {
            //     Id: 0,
            //     Name: "",
            //     TeamLeader: 0,
            //     Members: [
            //         {
            //             Id: 0,
            //             EmailAddress: "",
            //             FirstName: "",
            //             LastName: "",
            //             UserImage: null
            //         }
            //     ]
            // }
        ]
    }]

    public static GetWorkLocationdata: any = {
        Id: 0,
        EmailAddress: "",
        Status: "",
        CurrentWorkPlace: "",
        ActiveBooking: 0,
        DefaultWorkPlaces: {
            Monday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Tuesday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Wednesday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Thursday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Friday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Saturday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ],
            Sunday: [
                {
                    StartTime: "",
                    EndTime: "",
                    Place: ""
                }
            ]
        },
        WorkPlaceExceptions: [
            {
                Id: 0,
                WorkingPlace: "",
                Date: "",
                StartDateTime: "",
                EndDateTime: ""
            }
        ],
        ErrCode: null,
        ErrDesc: null,
        Date: "",
        StartDateTime: "",
        EndDateTime: ""
    }

    public static GetTeamsWorkplace: any = {
        TeamName: "",
        TeamMembers: [
            {
                Id: 0,
                EmailAddress: "",
                Name: "",
                UserImage: null,
                Role: "",
                DefaultWorkPlaces: {
                    Monday: [],
                    Tuesday: [],
                    Wednesday: [],
                    Thursday: [],
                    Friday: [],
                    Saturday: [],
                    Sunday: []
                },
                WorkPlaceException: []
            },

        ],
        ErrCode: null,
        ErrDesc: null,
        Id: 0,
        DateStart: "",
        DateEnd: ""
    }


    public static workPlacelist: any =
        [
            {
                Id: 0,
                Name: "",
                IconPath: "",
                LocationId: 0
            }
        ]


}

